import Image from 'next/image';
import { ReactElement } from 'react';
import styled from 'styled-components';

import ReverseTrial from '../../assets/images/LandingPage/ReverseTrial.png';
import theme from '../../assets/theme';
import TrialPageContent from '../../components/_organisms/TrialPageContent';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ReverseTrialPage: NextPageWithLayout = () => {
  return <TrialPageContent />;
};

const HeaderContainer = styled.div<{ $hideBlobs?: boolean }>`
  position: relative;
  background-image: url('/static/bground.svg');
  background-color: ${theme.colors.green};
  background-size: cover;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  color: ${theme.colors.white};
  height: 250px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px;

  h1 {
    font-size: 36px;
    margin: 0;
    color: ${theme.colors.white};
  }

  p {
    font-size: 20px;
    font-weight: 400;
    color: ${theme.colors.white};
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    height: fit-content;
    padding: 20px 10px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative !important;

  span {
    height: 100% !important;
    width: 100% !important;
    position: absolute !important;

    img {
      object-fit: contain !important;
      position: relative !important;
      height: 100% !important;
      width: 100% !important;
    }
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

const CustomHeader = () => {
  return (
    <HeaderContainer>
      <div style={{ maxWidth: 500, margin: 'auto ' }}>
        <h1>School Plan Trial</h1>
        <p>
          Everything you need to know about the School Plan Trial. How it works, what you
          get, and how to get started.
        </p>
      </div>
      <ImageWrapper>
        <Image
          style={{ objectFit: 'contain' }}
          alt="school plan trial image"
          height={ReverseTrial.height}
          width={ReverseTrial.width}
          src={ReverseTrial.src}
        />
      </ImageWrapper>
    </HeaderContainer>
  );
};

ReverseTrialPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      image={ReverseTrial}
      hideBlobs={false}
      hideActions={true}
      customHeader={<CustomHeader />}
      disableHeadline={true}
    >
      {page}
    </LandingPageLayout>
  );
};

export default ReverseTrialPage;
